import { memo } from 'react';
import { SwiperSlide } from 'swiper/react';
import SliderSection from '../../vouchers/slider-section';
import { MyVoucher } from '~/interfaces/vouchers';
import VoucherCard from '~/components/vouchers/voucher-card';
import ShareVoucher from '~/components/vouchers/share';
import { Translate, useTranslate } from '~/i18n';
import dynamic from 'next/dynamic';
const RedeemVoucher = dynamic(() => import('./redeem'), { ssr: false });
type VouchersSectionProps = {
   vouchers: MyVoucher[];
   active: boolean;
   // eslint-disable-next-line no-unused-vars
   handleRedeem: (code: string) => Promise<void>;
};

const VouchersSection = ({ vouchers, active, handleRedeem }: VouchersSectionProps) => {
   const { lang, translate } = useTranslate();

   const content = active
      ? vouchers.map((voucher, idx) => (
           <SwiperSlide key={idx}>
              <div className="w-full">
                 <VoucherCard
                    amount={voucher.amount}
                    code={voucher.code}
                    custom_background={voucher.custom_background}
                    isSmall={true}>
                    <div className="h-28 lg:h-20">
                       <div className="absolute bottom-0 flex items-center justify-center w-full m-auto space-x-2 text-sm transform translate-y-4 rtl:space-x-reverse">
                          <div>
                             <ShareVoucher
                                shareTitle={
                                   lang?.split('-')[1] === 'en' ? voucher.name.en : voucher.name.ar
                                }
                                shareDescription={translate({
                                   id: 'vouchers:share message',
                                   values: {
                                      amount: `${voucher.amount}`,
                                      code: `${voucher.code}`,
                                   },
                                })}>
                                <Translate id="common:share" />
                             </ShareVoucher>
                          </div>
                          <div>
                             <RedeemVoucher
                                amount={voucher.amount}
                                code={voucher.code}
                                handleRedeem={handleRedeem}
                             />
                          </div>
                       </div>
                    </div>
                 </VoucherCard>
              </div>
           </SwiperSlide>
        ))
      : vouchers.map((voucher, idx) => (
           <SwiperSlide key={idx}>
              <div className="w-full opacity-70">
                 <VoucherCard
                    amount={voucher.amount}
                    custom_background={voucher.custom_background}
                    isSmall={true}>
                    <div className="h-28 lg:h-20"></div>
                 </VoucherCard>
              </div>
           </SwiperSlide>
        ));

   return (
      <div className="text-gray-700">
         <SliderSection id={active ? 'active-vouchers' : 'redeemed-vouchers'} content={content} />
      </div>
   );
};

export default memo(VouchersSection);
